//Minimum eight characters, max 30, at least one letter, one number, one special character and one uppercase
//Testare su https://regexr.com/
//                                                                  \W               <- la negazione (perchè in maiuscolo) dei caratteri non speciali
//                                                                    _              <- l'underscore (che non è un carattere speciale)
export const PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,30}$/

/**
 * Minimum eight characters, at least one letter and one number:

   "^(?=.[A-Za-z])(?=.\d)[A-Za-z\d]{8,}$"
   Minimum eight characters, at least one letter, one number and one special character:

   "^(?=.[A-Za-z])(?=.\d)(?=.[@$!%#?&])[A-Za-z\d@$!%*#?&]{8,}$"
   Minimum eight characters, at least one uppercase letter, one lowercase letter and one number:

   "^(?=.[a-z])(?=.[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$"
   Minimum eight characters, at least one uppercase letter, one lowercase letter, one number and one special character:

   "^(?=.[a-z])(?=.[A-Z])(?=.\d)(?=.[@$!%?&])[A-Za-z\d@$!%?&]{8,}$"
   Minimum eight and maximum 10 characters, at least one uppercase letter, one lowercase letter, one number and one special character:

   "^(?=.[a-z])(?=.[A-Z])(?=.\d)(?=.[@$!%?&])[A-Za-z\d@$!%?&]{8,10}$"

 */
export const EMAIL_REGEX = /^(?:[a-z0-9!#$%&'*+\/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+\/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/

export const PHONE_REGEX = /^\+(9[976]\d|8[987530]\d|6[987]\d|5[90]\d|42\d|3[875]\d|2[98654321]\d|9[8543210]|8[6421]|6[6543210]|5[87654321]|4[987654310]|3[9643210]|2[70]|7|1)\W*\d\W*\d\W*\d\W*\d\W*\d\W*\d\W*\d\W*\d\W*(\d{1,2})$/

export const EIGHT_NUMBER_OTP_REGEX = /^[0-9]{8}$/

export const SIX_NUMBER_OTP_REGEX = /^[0-9]{6}$/